import React from 'react';
import {useTranslation} from 'react-i18next';

const SecurityExpert = ({text, imageDesktop, imageMobile}) => {

  const {t} = useTranslation();
  const {REACT_APP_LANGUAGE} = process.env;

  return (
    <div className="security-expert">

      <div role='button' tabIndex={-1} className="helper-button">
        <div className="inner-wrap">
          <div className="the-icon">
            <span className="icon expert" />
            <p>{t('expert.button')}</p>
          </div>
        </div>
      </div>

      <div className="helper-text">
        <span style={{ display: 'none' }} className="icon close-helper"/>
        <div className="inner-wrap">
          <div className="top">
            <div className={`expert-image ${REACT_APP_LANGUAGE.toLowerCase()}`}/>
            <div className="expert-info">
              <h4>{t('expert.title')}</h4>
              <h3>{t(`expert.name.${REACT_APP_LANGUAGE.toLowerCase()}`)}</h3>
            </div>
          </div>
          <div style={{ display: 'none' }} tabIndex={0} className="text" 
            id="expert-scroll"
          >
            {REACT_APP_LANGUAGE === 'lt' && (
              <p>„{text}“</p>
            )}
            {REACT_APP_LANGUAGE !== 'lt' && (
              <p>"{text}"</p>
            )}
            {imageDesktop && (
              <img src={imageDesktop} data-full={imageDesktop} alt=""/>
            )}
            {imageMobile && (
              <img className="mobile_correct" src={imageMobile} data-full={imageMobile} alt=""/>
            )}
          </div>
        </div>
      </div>

    </div>
  );
};

export default SecurityExpert;
